import { CellColorTag } from '../components'

const addRowColorTag = (columns, defaultTagColor) => {
	let columnsWithColortag = columns.map(col => ({ show: true, ...col }))
	const firstVisibleColIndex = columnsWithColortag.findIndex(col => col.show)
	if(firstVisibleColIndex >= 0) {
		const cellRenderer = columnsWithColortag[firstVisibleColIndex].Cell
		columnsWithColortag[firstVisibleColIndex].Cell = CellColorTag(defaultTagColor, cellRenderer)
	}
	return columnsWithColortag
}

export default addRowColorTag
